import { render, staticRenderFns } from "./DuplicateProductDialog.vue?vue&type=template&id=3e493592"
import script from "./DuplicateProductDialog.vue?vue&type=script&lang=js"
export * from "./DuplicateProductDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports